export default "INSURANCE_SEARCH_MODULE"
